import React, { useState } from "react";
import areasOfExpertise from "./../assets/areas-of-expertise.jpg";
import compass from "./../assets/compass.jpeg";
import blog from "./../assets/blog-photo.jpg";
import faqs from "./../assets/faqs-foto.jpg";
import about from "./../assets/about.jpg";
import { useNavigate } from "react-router-dom";

const CardSlider = () => {
  const navigate = useNavigate();

  const [cards, setCards] = useState([
    { id: 1, title: "Hakkımda", img: about, path: "/about", targetId: "about" },
    {
      id: 2,
      title: "Çalışma Alanlarım",
      img: areasOfExpertise,
      path: "/programs",
      targetId: "areasOfExpertise",
    },
    {
      id: 3,
      title: "Terapi Yaklaşımlarım",
      img: compass,
      path: "/programs",
      targetId: "therapyApproaches",
    },
    { id: 4, title: "Blog", img: blog, path: "/blog", targetId: "blog" },
    {
      id: 5,
      title: "Sık Sorulanlar",
      img: faqs,
      path: "/contact",
      targetId: "faqs",
    },
  ]);

  const scrollRight = () => {
    // En baştaki elemanı alıp en sona ekliyoruz
    setCards((prevCards) => {
      const [first, ...rest] = prevCards;
      return [...rest, first];
    });
  };

  const scrollLeft = () => {
    // En sondaki elemanı alıp en başa ekliyoruz
    setCards((prevCards) => {
      const last = prevCards[prevCards.length - 1];
      const rest = prevCards.slice(0, -1);
      return [last, ...rest];
    });
  };

  const handleCardClick = (card) => {
    navigate(`${card.path}#${card.targetId}`);
  };

  return (
    <div className="position-relative mt-5 px-md-5 overflow-hidden">
      {/* Sol Ok */}
      <button
        className="btn btn-dark rounded-circle d-flex align-items-center justify-content-center position-absolute top-50 start-0 translate-middle-y shadow-lg"
        onClick={scrollLeft}
        style={{
          zIndex: 10,
          width: "45px",
          height: "45px",
          opacity: "0.9",
          marginLeft: "15px",
        }}
      >
        <span>❮</span>
      </button>

      {/* Kart Alanı */}
      <div
        className="d-flex justify-content-center align-items-center mb-5"
        style={{
          gap: "1.5rem",
          padding: "2rem",
          transition: "all 0.5s ease-in-out",
        }}
      >
        {cards.slice(0, 5).map((card, index) => (
          <div
            key={card.id}
            className={`card text-bg-light shadow ${
              index === 2 ? "scale-up" : "scale-down"
            }`}
            onClick={() => handleCardClick(card)}
            style={{
              width: "300px",
              borderRadius: "20px",
              overflow: "hidden",
              transition: "transform 0.5s ease",
              cursor: "pointer",
            }}
          >
            <div style={{ height: "350px" }}>
              <img
                src={card.img}
                alt={card.title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <div className="card-body bg-white text-center">
              <h5 className="text-uppercase card-title fw-bold fs-6 m-0">
                {card.title}
              </h5>
            </div>
          </div>
        ))}
      </div>

      {/* Sağ Ok */}
      <button
        className="btn btn-dark rounded-circle d-flex align-items-center justify-content-center position-absolute top-50 end-0 translate-middle-y shadow-lg"
        onClick={scrollRight}
        style={{
          zIndex: 10,
          width: "45px",
          height: "45px",
          opacity: "0.9",
          marginRight: "15px",
        }}
      >
        <span>❯</span>
      </button>

      <style>{`
        .scale-up { transform: scale(1.05); z-index: 2; }
        .scale-down { transform: scale(0.9); opacity: 0.7; }
        @media (max-width: 768px) {
            .card:not(:first-child) { display: none; } /* Mobilde tek kart göster */
        }
      `}</style>
    </div>
  );
};

export default CardSlider;
